import ValidationMessage from './ValidationMessage'
import Customer from './Customer'
import Request from './Request'
export class Response {
    Success: boolean;
    RequestID?: number;
    RequestTypeID?: number;
    EmployeeID?: number;
    ValidationMessages: ValidationMessage[];
    Customers?: Customer[];
    Requests?: Request[];
    MassUpdateRecords?: any[];
    Columns?: any;
}

export default Response;